/* @flow weak */

'use strict';

const _ = require('lodash');
const { default: GuaranteeText } = require('../constraints/GuaranteeText.js');

const BaseConfig = {
  loaderStrategy: 'default',
  features: {
    ctaName: true,
    ctaPrice: true,
    previewName: false,
    previewPrice: false,
    socialSharing: true,
    socialSharingPrintOnly: false,
    addToCartButtons: 'both',
    addToCartAction: 'redirect',
    addToCartButtonExtraClass: false,
    wrapperExtraClass: false,
    bypassCartConfirmation: false,
    displayPartSaleLabel: true,
    cartButtonText: {en_US: 'Add To Cart', fr_CA: 'Ajouter Au Panier'},
    startingAtText: {en_US: 'Starting at', fr_CA: 'À partir de'},
    saveMyDesignText: {en_US: 'Save My Design', fr_CA: 'Enregistrer Mon Design'},
    shareMyDesignText: {en_US: 'Share My Design', fr_CA: 'Partager Mon Design'},
    nextButtonText: {en_US: 'NEXT', fr_CA: 'PROCHAINE'},
    finishButtonText: {en_US: 'FINISH', fr_CA: 'FINITION'},
    completeRequiredFieldsText: {en_US: 'Please make all required choices', fr_CA: 'Veuillez faire tous les choix requis'},
    errorMessageText: {en_US: 'We\'re experiencing issues adding this item to your cart. Please try again by clicking "Add to Cart" or refreshing the page.',
      fr_CA: 'Nous rencontrons des difficultés pour ajouter cet article à votre panier. Veuillez réessayer en cliquant sur "Ajouter au panier" ou en actualisant la page.'
    },
    pleaseCompleteText: {en_US: 'Please complete ', fr_CA: 'Veuillez compléter'},
    requiredFieldText: {en_US: 'required field', fr_CA: 'champ obligatoire'},
    requiredChoiceText: {en_US: 'required choice', fr_CA: 'choix requis'},
    useCapitalText: {en_US: 'Please use only capital letters (A-Z) in this field.', fr_CA: 'Veuillez utiliser uniquement des lettres majuscules (A-Z) dans ce champ.'},
    useCapitalOrNumText: {en_US: 'Please use only letters (A-Z), numbers (0-9) or spaces in this field.', fr_CA: 'Veuillez utiliser uniquement des lettres (A-Z), des chiffres (0-9) ou des espaces dans ce champ.'},
    useCapitalOrNumOrCharactersText: {en_US: 'Please use only letters (A-Z), numbers (0-9), spaces, or the following characters: # ! \' , " - . ( ) : ; ? & < / . Â Ä À Á Ã Å Ê Ë È É Î Ï Ì Í Ô Ö Ó Û Ü Ù Ú Ñ', 
      fr_CA: 'Veuillez utiliser uniquement des lettres (A-Z), des chiffres (0-9), des espaces ou les caractères suivants : # ! \' , " - . ( ) : ; ? & < / . Â Ä À Á Ã Å Ê Ë È É Î Ï Ì Í Ô Ö Ó Û Ü Ù Ú Ñ'},
    useCapitalOrNumOrCharactersText: {en_US: 'Please use only letters (A-Z), numbers (0-9), spaces, or the following characters: # ! \' , " - . ( ) : ; ? & < / . Â Ä À Á Ã Å Ê Ë È É Î Ï Ì Í Ô Ö Ó Û Ü Ù Ú Ñ', 
      fr_CA: 'Veuillez utiliser uniquement des lettres (A-Z), des chiffres (0-9), des espaces ou les caractères suivants : # ! \' , " - . ( ) : ; ? & < / . Â Ä À Á Ã Å Ê Ë È É Î Ï Ì Í Ô Ö Ó Û Ü Ù Ú Ñ'},
    useCapitalOrNumOrPunctuationsText: {en_US: 'Please use only letters (A-Z), numbers (0-9), spaces, or the following punctuation: # ! \' , " - . ( ) : ; ? & < / .', 
        fr_CA: 'Veuillez utiliser uniquement des lettres (A-Z), des chiffres (0-9), des espaces ou la ponctuation suivante : # ! \' , " - . ( ) : ; ? & < / .'},
    useNumbersOnlyText: {en_US: 'Please use only numbers in this field.', fr_CA: 'Veuillez n\'utiliser que des chiffres dans ce champ.'},
    useDateFormatText: {en_US: 'Please enter the birth date in the following format: MMDDYYYY.', fr_CA: 'Veuillez saisir la date de naissance au format suivant: MMDDYYYY.'},
    textIsNotAllowedText: {en_US: 'This text is not allowed.', fr_CA: 'Ce texte n\'est pas autorisé.'},
    guaranteeApprovedText: {en_US: 'Your order has qualified for Guaranteed Graduation Delivery!', fr_CA: 'Votre commande est admissible à la livraison garantie pour la remise des diplômes!'},
    guaranteeIsNotApprovedText: {en_US: 'Warning: Orders with 6 weeks between order date and the graduation date specified will be guaranteed for delivery by graduation. The graduation date entered is less than 6 weeks or more than 3 months away from today and this order will not be guaranteed for graduation. Balfour thanks you for ordering and will provide you with a college ring that will be a source of pride and enjoyment for many years to come!', 
      fr_CA: 'Attention : les commandes avec 6 semaines entre la date de commande et la date de remise des diplômes spécifiée seront garanties pour une livraison avant la remise des diplômes. La date d\'obtention du diplôme saisie est dans moins de 6 semaines ou dans plus de 3 mois à compter d\'aujourd\'hui et cette commande ne sera pas garantie pour l\'obtention du diplôme. Balfour vous remercie pour votre commande et vous fournira une bague universitaire qui sera une source de fierté et de plaisir pour de nombreuses années à venir !'},
    optionalText: {en_US: 'optional', fr_CA: 'facultatif'},
    notFinishedText: {en_US: 'Not Quite Finished Yet!', fr_CA: 'Pas Encore Tout À Fait Fini!'},
    questionHaveErrorsText: {en_US: 'The following questions are incomplete or have errors', fr_CA: 'Les questions suivantes sont incomplètes ou comportent des erreurs'},
    chooseDropdownText: {en_US: 'Choose...', fr_CA: 'Choisis...'},
    charactersLeftText: {en_US: 'characters left', fr_CA: 'caractères restants'},
    previewImgZoomBtn: true,
    enableHoverZoom: true,
    selectionSummary: true,
    productDetailsPosition: 'bottom',
    requireCustomerDataForPrint: true
  },
  analytics: {
    enableTracking: false,
    eventCategory: 'Universal Configurator Personalization'
  },
  productline: {
    CollegeRings: 1,
    ArtCarvedClassRings: 2,
    ArtCarvedFamilyJewelry: 3,
    ScholasticHighSchoolRings: 4,
    HighSchoolSportsAwards: 5,
    CollegeSportsAwards: 6,
    WalmartClassRings: 7,
    WalmartFamilyJewelry: 8,
    WalmartMilitaryServiceRings: 9,
    KSUNIVCollections: 12
  },
  images: {
    s3url: 'https://s3.amazonaws.com/uc-source/',
    cantoUrl: 'https://edge.prod.cdn.aac-e.com/aac-images/GetImage?sku={sku}&smi={smi}&requestedImageType=LowJPG',
    imageRendererEnv: 'production',
    imageRendererType: 'static',
    imageRendererViews: ['top'],
    liquifire: {
      imageRendererEndPoint: 'https://combi.liquifire.com/combi',
      imageRendererVersion: 'v1'
    }
  },
  breakpoints: {
    small: 676,
    medium: 1024,
    large: 1440,
    extraLarge: 1920
  },
  previewSectionWidthMultiplier: 0.5, // % of main UC div
  fixedHeaderHeightSmall: 0,
  fixedHeaderHeightMedium: 0,
  fixedHeaderHeightLarge: 0,
  keyCodes: {
    TAB: 9,
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    ESC: 27
  },
  skuPricing: false,
  currency: {
    US: '$',
    USA: '$',
    CANADA: 'CAD$',
    default: '$'
  }
};

let Config;

if (__VENDOR__ === 'shop') {
  Config = require('./Config.shop.js');
}
if (__VENDOR__ === 'balfour') {
  Config = require('./Config.balfour.js');
}
if (__VENDOR__ === 'artcarved') {
  Config = require('./Config.artcarved.js');
}
if (__VENDOR__ === 'walmart') {
  Config = require('./Config.walmart.js');
}
if (__VENDOR__ === 'netsuite') {
  Config = require('./Config.netsuite.js');
}
if (__VENDOR__ === 'aafes') {
  Config = require('./Config.aafes.js');
}
if (__VENDOR__ === 'zales') {
  Config = require('./Config.zales.js');
}
if (__VENDOR__ === 'signet') {
  Config = require('./Config.signet.js');
}
if (__VENDOR__ === 'daniels') {
  Config = require('./Config.daniels.js');
}
if (__VENDOR__ === 'jcp') {
  Config = require('./Config.jcp.js');
}
if (__VENDOR__ === 'bowling') {
  Config = require('./Config.bowling.js');
}
if (__VENDOR__ === 'balfoursports') {
  Config = require('./Config.balfoursports.js');
}
if (__VENDOR__ === 'reeds') {
  Config = require('./Config.reeds.js');
}
if (__VENDOR__ === 'militarymilestones') {
  Config = require('./Config.militarymilestones.js');
}

module.exports = _.merge(BaseConfig, Config);


// WEBPACK FOOTER //
// ./src/base/scripts/configs/Config.js